import { useState } from "react"
import QRCode from "react-qr-code"
import { Col, Row } from "../Assets/style"
import { useLocation, useParams, useNavigate } from "react-router-dom"
import { burnTokenPath } from "../../module/routes/path"
import { Container } from "./style"
import { ReactComponent as SuccessIcon } from '../../assets/success_icon.svg'
import { SubtitleMedium, BodyRegular, WarningText } from "../../shared/typography"
import Button from "../../components/Button"
import link_small from "../../assets/icons/link_small.svg";
// import arrow_down from "../../assets/icons/arrow_down.svg";
import { ReactComponent as Arrow_down } from '../../assets/icons/arrow_down.svg'

export const SignatureVerificationSection = ({ assetWallet, setIsBurn, selectedProxyTokenInitMint, isVerified }: { setIsBurn: Function; assetWallet: string; selectedProxyTokenInitMint: any; isVerified: boolean }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const { assetContractAddress } = useParams();
    const [isCopying, setIsCopying] = useState(false)

    const getLink = () => {
        const pathArr = pathname?.split('/')
        pathArr.splice(0, 2)        
        return window?.location?.origin + burnTokenPath + '/' + pathArr?.join('/') + `/${selectedProxyTokenInitMint?.token_id}`
    }

    return (
        <Container>
            {
                isVerified
                    ? <>
                        <Col align="center">
                            <Col align="start" width="100%">
                                <Row gap="70px" align="center">
                                    <Row align="center" className="backButton" onClick={() => setIsBurn(false)}>
                                        <Arrow_down className="backIcon" />
                                        <BodyRegular color="#A29B8B">Back</BodyRegular>
                                    </Row>
                                </Row>
                                <SubtitleMedium textAlign="center" className="titleText">Signature Verified</SubtitleMedium>
                            </Col>
                            <SuccessIcon />
                            <WarningText textAlign="center" className="descText">You can, now burn your proxy token</WarningText>
                        </Col>
                    </>
                    : <Col gap="25px">
                        <Col>
                            <Row gap="70px" align="center">
                                <Row align="center" className="backButton" onClick={() => setIsBurn(false)}>
                                    <Arrow_down className="backIcon" />
                                    <BodyRegular color="#A29B8B">Back</BodyRegular>
                                </Row>
                            </Row>
                            <SubtitleMedium textAlign="center">Verify Your Identity</SubtitleMedium>
                        </Col>
                        <Col gap="75px">
                            <Row justify="center">
                                <QRCode
                                    style={{ height: "auto", maxWidth: "200px", width: "200px" }}
                                    value={`value`}
                                />
                            </Row>
                            <Row justify="center">
                                <Button
                                    onClick={() => {
                                        navigator.clipboard.writeText(getLink());
                                        setIsCopying(true);
                                        setTimeout(() => {
                                            setIsCopying(false);
                                        }, 600);
                                    }}
                                    isDisabled={isCopying}
                                    type="BLACK"
                                >
                                    {isCopying ? 'Copied' : 'Copy Link'}
                                </Button>
                                <a href={getLink()} target="blank">
                                    <Button
                                        onClick={() => { }}
                                        IconHeight='15px'
                                        type="YELLOW"
                                        iconSrc={link_small}
                                    >
                                        Open Link
                                    </Button>
                                </a>
                            </Row>
                        </Col>
                    </Col>
            }
        </Container>
    )
}
//     <CustomTextbar
// config={{
//     title: 'Link',
//     value: `/${shortenAddress(assetWallet)}/${shortenAddress(assetContractAddress || '')}`
// }}
// link={getLink()}
// />